import { throwError } from "@/lib/throwError";
import { get, post } from "@/services/axiosUitils";
import {
  ActionPayload,
  UserPreferencesData,
} from "@/utils/types/userPreferencesGrid";

export default class UserPreferencesService {
  static addUserPreferencesGrid = async (
    payload: ActionPayload
  ): Promise<UserPreferencesData> => {
    if (!payload) {
      throwError("Payload is required", "UserPreferencesService");
    }
    return await post<UserPreferencesData>(
      "user-preferences-general/",
      payload
    );
  };

  static getUserPreferencesGrid = async (): Promise<UserPreferencesData> => {
    return await get<UserPreferencesData>("user-preferences-general/");
  };
}
